// This is a magic string replaced by rollup

const SDK_VERSION = "10.39.0" ;

export { SDK_VERSION };
